import request from '@/utils/request'

const USER_ROUTE = 'api/v1/search/'

export const searchOrders = (data: any, keyword?: string) => {
  const querystring = keyword ? `?keyword=${keyword}` : null

  const test = `orders${querystring || ''}`
  console.log(test)

  return request({
    url: USER_ROUTE + `orders${querystring || ''}`,
    method: 'post',
    data
  })
}

export const searchVendors = (data: any, keyword?: string) => {
  const querystring = keyword ? `?keyword=${encodeURIComponent(keyword)}` : null
  return request({
    url: USER_ROUTE + `vendors${querystring || ''}`,
    method: 'post',
    data
  })
}
